import React, { useEffect } from "react";
import Describe from "./Describe";
import Button from "react-bootstrap/Button";
import "./Cards.css";
import "aos/dist/aos.css";
import Aos from "aos";

import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const cards = [
  {
    id: 1,
    name: "Text Utils",
    author: ["Nahal"],
    description:
      "Text editor",
    technologies: [
      "HTML",
      "CSS",
      "BOOTSTRAP",
      "JS",
      "REACT"
    ],
    url: "https://your-text-utilities.vercel.app/",
  },
  { id: 2,
    name: "Github Users Searcher",
    author: ["Nahal"],
    description:
      "A website that generates text for you",
    technologies: [
      "HTML",
      "CSS",
      "JS"
    ],
    url: "https://nahal-mughal.github.io/search-github-users-api.github.io/",
  },
  
  { id: 3,
    name: "Random Text Generator",
    author: ["Nahal"],
    description:
      "A website that generates text for you",
    technologies: [
      "HTML",
      "CSS",
      "JS"
    ],
    url: "https://nahal-mughal.github.io/random-text.github.io/",
  },

];

function Cards() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="container-fluid cards__container align-items-center py-5" data-aos="fade-up">
      <div className="container">
        <div className="row align-items-center justify-content-center text-center pt-5 project-title">
          <h1>PROJECT</h1>
          <span>This is a summary of my personal projects.</span>
          <p>
            Hope you like them and we can work together<span role="img" aria-label="Handshake">🤝</span>.
          </p>
        </div>

        <div className="container">
          <div className="row align-items-center justify-content-center py-3">
            {cards.map((card) => (
              <div className="col-sm my-2" data-aos="zoom-in" key={card.id}>
                <Describe
                  name={card.name}
                  imageSrc={card.image}
                  author={card.author}
                  Description={card.description}
                  Technologies={card.technologies}
                  Url={card.url}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="row text-center">
          <Container data-aos="zoom-in-up">
            <Link to="/projects">
              <Button variant="outline-dark" size="lg">
                View all Project
              </Button>
            </Link>
          </Container>
        </div>

      </div>
    </section>
  );
}

export default Cards;
